import { DeliveryChannel, NotificationPriority } from '@src/api';

export const defaultValues = {
  selectionId: 0,
  notificationPriority: NotificationPriority.High,
  deliveryChannelTypes: [DeliveryChannel.VivicaNotifications],
  subject: '',
  description: '',
};

export const priorities = [
  { name: NotificationPriority.High, value: NotificationPriority.High },
  { name: NotificationPriority.Medium, value: NotificationPriority.Medium },
  { name: NotificationPriority.Low, value: NotificationPriority.Low },
];

export const channels = [
  { name: 'Vivica notifications', value: DeliveryChannel.VivicaNotifications },
  { name: 'Email', value: DeliveryChannel.Email },
];
